import { DataTable, DeleteDialog, Heading, Loader } from "@/components";
import { Input, Button } from "@/components/ui";
import { Search } from "lucide-react";
import useUsers from "./useUsers";
import { useIsMobile } from "@/hooks/use-mobile";
import { ResetPassword } from "@/pages";

const Users = () => {
  const {
    onAddUser,
    globalFilter,
    setGlobalFilter,
    columns,
    breadcrumbData,
    propertyDetails,
    openDialog,
    onClose,
    onConfirm,
    isDeletePending,
    selectedRow,
    onRowClick,
    openResetDialog,
    setOpenResetDialog,
    usersGridData,
    pageNumber,
    pageSize,
    setPageNumber,
    setPageSize,
    sorting,
    setSorting,
    isLoading
  } = useUsers();
  const isMobile = useIsMobile();

  return (
    <div className="p-4 md:p-6">
      {/* Header & Search */}
      <div className="flex flex-col xl:flex-row gap-2 xl:items-center xl:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading
            title={propertyDetails?.name}
            breadcrumbData={breadcrumbData}
          />
          {isMobile && (
            <Button onClick={onAddUser} className="px-2">
              + Associate User
            </Button>
          )}
        </div>
        <div className="flex flex-row items-center gap-4">
          {/* <Button className="bg-white text-g-500 border-g-200 border-1 hover:bg-white">
            <ListFilterIcon />
          </Button> */}
          <Input
            type="text"
            placeholder="Search"
            value={globalFilter ?? ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
            className="w-full sm:w-72 bg-white h-[40px]"
            startIcon={<Search className="w-4 h-4" />}
          />
          {!isMobile && <Button onClick={onAddUser}>+ Associate User</Button>}
        </div>
      </div>

      {/* Responsive Table */}
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <DataTable
            data={usersGridData?.data?.sort((a: any, b: any) => {
              if (a.endDate === null && b.endDate !== null) return -1;
              if (a.endDate !== null && b.endDate === null) return 1;
              return 0;
            }) || []}
            columns={columns}
            globalFilter={globalFilter}
            setGlobalFilter={setGlobalFilter}
            pageNumber={pageNumber}
            pageSize={pageSize}
            setPageNumber={setPageNumber}
            setPageSize={setPageSize}
            totalPages={Math.ceil(usersGridData?.total / pageSize)}
            totalRecords={usersGridData?.total}
            serverSidePagination={true}
            sorting={sorting}
            onSortingChange={setSorting}
            onRowClick={onRowClick}
          />
        </>
      )}
      {openDialog && <DeleteDialog
        open={openDialog}
        onClose={onClose}
        onConfirm={onConfirm}
        isLoading={isDeletePending}
        contents={[
          <div>
            {`Deleting `}
            <b className="text-primary">
              {selectedRow?.firstName} {selectedRow?.lastName}
            </b>
            {` user will permanently remove all related data. This action cannot be undone. Do you want to proceed?`}
          </div>,
          <div>
            <div>
              {`Deleting `}
              <b className="text-primary">
                {selectedRow?.firstName} {selectedRow?.lastName}
              </b>
              {` user will permanently remove all related data. This action cannot be undone. Do you want to proceed? Below are items affected:`}
            </div>
            <div className="flex flex-col gap-1 mt-2">
              <span>
                <i className="text-primary">Number of financial Records : </i>0
              </span>
            </div>
          </div>,
        ]}
      />}
      <ResetPassword open={openResetDialog} setOpen={setOpenResetDialog} selectedUser={selectedRow} />
    </div>
  );
};

export default Users;
